import { NavLink, useNavigate } from "react-router-dom";
import { Home, Dumbbell, Utensils, LineChart, User } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const items = [
  { to: "/", label: "Home", icon: Home, testid: "nav-home" },
  { to: "/program", label: "Program", icon: Dumbbell, testid: "nav-program" },
  { to: "/fuel", label: "Fuel", icon: Utensils, testid: "nav-fuel" },
  { to: "/progress", label: "Progress", icon: LineChart, testid: "nav-progress" },
  { to: "/profile", label: "Profile", icon: User, testid: "nav-profile" },
];

export default function AppShell({ children }) {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen grain relative" style={{ background: "#0A0A0A" }}>
      {/* Sticky top bar */}
      <header
        className="sticky top-0 z-40 backdrop-blur-xl"
        style={{ background: "rgba(10,10,10,0.75)", borderBottom: "1px solid #27272A" }}
      >
        <div className="max-w-6xl mx-auto flex items-center justify-between px-5 py-4">
          <div
            className="font-display font-black text-2xl tracking-tighter cursor-pointer"
            style={{ letterSpacing: "-0.04em" }}
            onClick={() => navigate("/")}
            data-testid="app-logo"
          >
            CINDR <span style={{ color: "#FF0055" }}>REBUILD</span>
          </div>
          <div className="hidden md:flex items-center gap-2">
            {items.map((it) => (
              <NavLink
                key={it.to}
                to={it.to}
                end={it.to === "/"}
                data-testid={`top-${it.testid}`}
                className={({ isActive }) =>
                  `px-3 py-2 text-xs font-bold uppercase tracking-widest transition-colors ${
                    isActive ? "text-white border-b-2" : "text-zinc-400 hover:text-white"
                  }`
                }
                style={({ isActive }) => (isActive ? { borderColor: "#FF0055" } : {})}
              >
                {it.label}
              </NavLink>
            ))}
          </div>
          <div className="flex items-center gap-3">
            {user?.role === "admin" && (
              <NavLink to="/admin" data-testid="header-admin-link" className="hidden sm:inline-block text-[9px] font-bold uppercase tracking-widest px-2 py-1 transition-colors text-zinc-300 hover:text-white" style={{ border: "1px solid #3f3f46" }}>
                Numbers
              </NavLink>
            )}
            {user?.is_member && (
              <span className="hidden sm:inline-block text-[9px] font-bold uppercase tracking-widest px-2 py-1" style={{ border: "1px solid #FF0055", color: "#FF0055" }} data-testid="header-member-pill">
                Member
              </span>
            )}
            <div className="text-xs eyebrow hidden sm:block" data-testid="header-user">
              {user?.name?.split(" ")[0] || "Rebuild"}
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-5 pb-28 pt-6 relative z-10">{children}</main>

      {/* Bottom tab bar (mobile) */}
      <nav
        className="md:hidden fixed bottom-0 left-0 right-0 z-40 backdrop-blur-xl"
        style={{ background: "rgba(0,0,0,0.9)", borderTop: "1px solid #27272A" }}
      >
        <div className="flex justify-around py-2">
          {items.map((it) => {
            const Icon = it.icon;
            return (
              <NavLink
                key={it.to}
                to={it.to}
                end={it.to === "/"}
                data-testid={it.testid}
                className={({ isActive }) =>
                  `flex flex-col items-center justify-center gap-1 py-2 px-3 flex-1 transition-colors ${
                    isActive ? "text-white" : "text-zinc-500"
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    <Icon size={20} strokeWidth={isActive ? 2.5 : 2} color={isActive ? "#FF0055" : undefined} />
                    <span className="text-[10px] uppercase tracking-widest font-bold">{it.label}</span>
                  </>
                )}
              </NavLink>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
